import React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import Player from './player';

export default class NavMenu extends React.Component {
  constructor (props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle () {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render () {
    return (
        <header>
            <Navbar fixed="top" className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3" light >
          <Container>
                    <NavbarBrand tag={Link} to="/">Music Manager Operations</NavbarBrand>
                    <Player />
            <NavbarToggler onClick={this.toggle} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                        <ul className="navbar-nav flex-grow">    
                            <NavItem>
                                <NavLink tag={Link}  to="/">Compilations</NavLink>
                            </NavItem> 
                            <NavItem>
                                <NavLink tag={Link} activeClassName="active" active={window.location.pathname.includes("/utilities")} to="/utilities">Utilities</NavLink>
                            </NavItem> 
                            <NavItem>
                                <NavLink tag={Link} activeClassName="active" active={window.location.pathname.includes("/Lists")} to="/Lists">Lists</NavLink>
                            </NavItem>   
                            <NavItem>
                                <NavLink tag={Link} activeClassName="active" active={window.location.pathname.includes("/tags")} to="/tags">Tags</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} activeClassName="active" active={window.location.pathname.includes("/sync")} to="/sync">Sync List</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} activeClassName="active" active={window.location.pathname.includes("/ml")} to="/ml">TagMyTrack</NavLink>
                            </NavItem>
                            <a className="nav-link" target="_blank" rel="noopener noreferrer" href="https://dashboard.musicmanagerops.com/">Dashboard</a>
                            
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js